import { Button } from '@fozito/common-ui';
import React from 'react';
import styled from 'styled-components';
type Props = {
  onClose?: () => void;
  hiddenClose?: boolean;
  okTitle?: string;
  disabledOk?: boolean;
};
const ModalActions = ({ hiddenClose, onClose, okTitle = 'OK', disabledOk }: Props) => {
  return (
    <ModalActionsStyled>
      {!hiddenClose && <Button onClick={onClose} type_cancel><span>Close</span></Button>}
      <Button disabled={disabledOk} type_primary type='submit'><span>{okTitle}</span></Button>
    </ModalActionsStyled>
  );
};

export default ModalActions;
const ModalActionsStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  button {
    flex: 1;
  }
  padding: 16px;
`;